export enum JotFormControlTypes {
  HEAD = 'control_head',
  TEXT = 'control_text',
  CHECKBOX = 'control_checkbox',
  RADIO = 'control_radio',
  YESNO = 'control_yesno',
  WIDGET = 'control_widget',
  TEXTBOX = 'control_textbox',
}

export enum JotFormWidgetTypes {
  FIELD = 'field',
}

interface JotFormResponse {
  responseCode: number;
  message: string;
}

interface JotFormCondition {
  action: string;
  id: string;
  index: string;
  link: string;
  priority: string;
  terms: string;
  type: string;
}

export interface JotFormQuestionResponse extends JotFormResponse {
  content: object;
}

export interface JotFormPropertyResponse extends JotFormResponse {
  content: {
    conditions: JotFormCondition[];
    thankYouPage: {
      title: string;
      subTitle: string;
      type: string;
      imageSrc: string;
      redirectLink: string;
    };
    welcomePage: {
      title: string;
      subTitle: string;
      buttonText: string;
      logo: string;
      isActive: string;
    };
  };
}

export interface JotFormSubmissionResponse extends JotFormResponse {
  content: {
    submissionID: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    URL: string;
  };
}

export interface JotFormQuestion {
  qid: string;
  type: string;
  order: string;
  name: string;
  text?: string;
  hidden?: string;
  options?: string;
  description?: string;
  subHeader?: string;
  termsText?: string;
  termsLink?: string;
  widgetType?: string;
  fieldParameters?: string;
}

export interface JotFormConditions {
  action: string;
  terms: string;
}
